import { LanguageService } from 'services/language-service';
import { ExportSmartAssistantLeadsDto, GetAllSmartAssistantLeadsDto, Lead } from 'shared/interfaces/Lead';
import { CollectLeadInfoToolExecutionDto } from 'shared/interfaces/tools/CollectLeadsInfo';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const collectLeadInfoToolBaseEndpoint = '/tools/collectLeadInfo';
const leadsBaseEndPoint = '/leads';

export const LeadsService = {
  saveLeadInformation: async (leadInformationDto: CollectLeadInfoToolExecutionDto): Promise<void> => {
    await axiosBaseInstance({
      method: 'post',
      url: `${collectLeadInfoToolBaseEndpoint}/execute`,
      data: leadInformationDto
    });
  },

  getSmartAssistantLeads: async (getSmartAssistantLeadsDto: GetAllSmartAssistantLeadsDto): Promise<Lead[]> => {
    const leadsResponse = await axiosBaseInstance({
      method: 'get',
      url: `${leadsBaseEndPoint}/with-smart-assistant/${getSmartAssistantLeadsDto.smartAssistantId}`,
      params: getSmartAssistantLeadsDto.getSmartAssistantLeadsQueryDto
    });

    return leadsResponse.data as Lead[];
  },

  exportSmartAssistantLeads: async (exportSmartAssistantLeads: ExportSmartAssistantLeadsDto): Promise<ArrayBuffer> => {
    const response = await axiosBaseInstance({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${leadsBaseEndPoint}/with-smart-assistant/${exportSmartAssistantLeads.smartAssistantId}/export`,
      params: {
        ...exportSmartAssistantLeads.query,
        exportType: exportSmartAssistantLeads.type,
        locale: LanguageService.getCurrentLanguage(),
        timezoneOffsetMs: new Date().getTimezoneOffset() * 60 * 1000 * -1 // -1 because getTimezoneOffset returns positive value for negative offset
      }
    });

    return response.data;
  }
};
